import { styled } from '@mui/material';

const Label = styled('label')``;

export default Label;
